<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import { on, off } from "@/libs/tools";
var echarts = require("echarts");
export default {
  name: "ChartPie",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        // if (val.length) {
          console.log(val)
          this.loadEcharts(val);
        // }
      },
    },
  },
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let option = {
          color:['#bbb1d5','#92cddc'],
          title: {
            text: this.text,
            subtext: this.subtext,
            left: "center",
            top:'38%'
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            type: "scroll",
            // orient: "vertical",
            right: 'center',
            // top: 20,
            bottom: '10%',
            // data: data.legendData,
          },
          series: [
            {
              // name: "新生预报到情况统计",
              type: "pie",
              radius: ["40%", "60%"],
              center: ["50%", "40%"],
              data: val,
              label: {
                formatter: "{b} : {c} ({d}%)",
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },
  mounted() {this.loadEcharts(this.value);},
  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>

